module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "Sin"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Sin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SINFONIA")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("Flames. That is how I remember Antonio Vivaldi: the flames of his red hair; the flames of the candles that flickered determinedly around him as he composed late at night; the fires he would kindle in the grate in the cold, dark winter, the red-orange glow lighting his bare skin; the passion with which he played the violin, such passion that I would not have been surprised had the strings, the bow, caught fire.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Music is a singular kind of passion; it envelops, surrounds, obsesses. To share that passion with another soul is to amplify it, to create a sort of intimacy unlike anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Vivaldi gave my life fire, passion, heat. There was a time when—without him—I was frozen; when I was like a corpse interred in a tomb of ice.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("And now that he is gone, the world is cold once again. Yet he is not gone forever. He lives on in the music he wrote; and in my memories. But with the pleasure of remembering, it seems, always comes pain; and if there is one thing I have learned in my life in Venice—this beautiful, incomparable city of water and music and masks and deception—it is that we must live through both pleasure and pain as best we can.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0b26b74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/sinfonia.vue
// module id = 72
// module chunks = 0